/* ==========================================================================
   LILIVIA Maison — theme.js
   Vanilla JS, no dependencies. Every feature is defensive: if the markup
   is not on the page, the feature quietly does nothing.
   ========================================================================== */
(function () {
  'use strict';

  var S = window.themeSettings || {};
  var ROUTES = S.routes || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- utils */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) { el.addEventListener(ev, fn, opts || false); } }
  function safe(fn) { return function () { try { fn.apply(this, arguments); } catch (err) { if (window.console) { console.warn('[lilivia]', err); } } }; }

  function lockScroll(lock) {
    document.body.classList.toggle('is-locked', !!lock);
  }

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = Number(parts[0]).toLocaleString('en-US') + '.' + parts[1];
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Number(parts[0]).toLocaleString('en-US'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  /* ------------------------------------------------------- header shadow */
  var header = $('.site-header');
  if (header) {
    var ticking = false;
    var applyHeader = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
      ticking = false;
    };
    on(window, 'scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(applyHeader); }
    }, { passive: true });
    applyHeader();
  }

  /* --------------------------------------------------- scroll progress bar */
  var progressBar = $('[data-scroll-progress]');
  if (progressBar) {
    var updateProgress = function () {
      var doc = document.documentElement;
      var max = (doc.scrollHeight - window.innerHeight);
      var pct = max > 0 ? (window.scrollY / max) * 100 : 0;
      progressBar.style.width = Math.max(0, Math.min(100, pct)) + '%';
    };
    on(window, 'scroll', updateProgress, { passive: true });
    on(window, 'resize', updateProgress);
    updateProgress();
  }

  /* --------------------------------------------------------- back to top */
  var toTop = $('[data-to-top]');
  if (toTop) {
    var toggleTop = function () { toTop.classList.toggle('is-visible', window.scrollY > 600); };
    on(window, 'scroll', toggleTop, { passive: true });
    on(toTop, 'click', function () { window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); });
    toggleTop();
  }

  /* ------------------------------------------------------ scroll reveal */
  var revealables = $$('.reveal');
  if (revealables.length) {
    if (!('IntersectionObserver' in window) || reduceMotion) {
      revealables.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      revealables.forEach(function (el) { io.observe(el); });
    }
  }

  /* ------------------------------------------------------ announcement bar */
  $$('[data-announce]').forEach(function (bar) {
    var closeBtn = $('[data-announce-close]', bar);
    var key = 'lilivia-announce-' + (bar.getAttribute('data-announce-id') || 'default');
    try { if (window.sessionStorage.getItem(key) === 'closed') { bar.style.display = 'none'; } } catch (e) {}
    on(closeBtn, 'click', function () {
      bar.style.display = 'none';
      try { window.sessionStorage.setItem(key, 'closed'); } catch (e) {}
    });
    var dur = bar.getAttribute('data-speed');
    var track = $('.announce__track', bar);
    if (track && dur) { track.style.animationDuration = dur + 's'; }
  });

  /* ------------------------------------------- announcement fade rotation */
  $$('[data-announce-fade]').forEach(function (bar) {
    var items = $$('.announce__fade-item', bar);
    if (items.length < 2 || reduceMotion) { return; }
    var i = 0;
    var interval = parseInt(bar.getAttribute('data-interval') || '5', 10) * 1000;
    var paused = false;
    window.setInterval(function () {
      if (paused) { return; }
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, interval);
    on(bar, 'mouseenter', function () { paused = true; });
    on(bar, 'mouseleave', function () { paused = false; });
    on(bar, 'focusin', function () { paused = true; });
    on(bar, 'focusout', function () { paused = false; });
  });
  /* ---------------------------------------------------------- marquee band */
  $$('[data-marquee-band]').forEach(function (band) {
    var dur = band.getAttribute('data-speed');
    var track = $('.marquee-band__track', band);
    if (track && dur) { track.style.animationDuration = dur + 's'; }
  });

  /* ------------------------------------------------------- signup popup */
  var nlPopup = $('[data-nl-popup]');
  if (nlPopup) {
    var nlKey = 'lilivia-signup-popup';
    var nlReturnKey = 'lilivia-signup-popup-return';
    var cooldownDays = parseInt(nlPopup.getAttribute('data-cooldown-days') || '14', 10);
    var lastSeen = null;
    var nlReturn = null;
    try { lastSeen = window.localStorage.getItem(nlKey); } catch (e) {}
    try {
      nlReturn = JSON.parse(window.sessionStorage.getItem(nlReturnKey));
      window.sessionStorage.removeItem(nlReturnKey);
    } catch (e) {}
    var cooling = lastSeen && (Date.now() - parseInt(lastSeen, 10)) < cooldownDays * 86400000;
    if (cooling) {
      nlPopup.parentNode.removeChild(nlPopup);
    } else {
      var nlShown = false;
      var nlOpen = function () {
        if (nlShown || !document.body.contains(nlPopup)) { return; }
        nlShown = true;
        nlPopup.hidden = false;
        window.requestAnimationFrame(function () { nlPopup.classList.add('is-open'); });
        lockScroll(true);
        var field = nlPopup.querySelector('input[type="email"]');
        if (field) { window.setTimeout(function () { field.focus({ preventScroll: true }); }, 90); }
      };
      var nlClose = function (remember) {
        nlPopup.classList.remove('is-open');
        window.setTimeout(function () { nlPopup.hidden = true; }, 320);
        lockScroll(false);
        if (remember !== false) { try { window.localStorage.setItem(nlKey, String(Date.now())); } catch (e) {} }
      };
      var nlSuccess = nlPopup.querySelector('.form-success');
      if (nlSuccess) {
        try { window.localStorage.setItem(nlKey, String(Date.now())); } catch (e) {}
        if (nlReturn && nlReturn.path === window.location.pathname) {
          $$('.newsletter__form-wrap .form-success').forEach(function (message) { message.hidden = true; });
          window.history.replaceState(null, document.title, nlReturn.path);
          window.scrollTo(0, nlReturn.top);
        }
        nlOpen();
      } else {
        window.setTimeout(nlOpen, parseInt(nlPopup.getAttribute('data-delay') || '7', 10) * 1000);
        var nlScrollPct = parseInt(nlPopup.getAttribute('data-scroll') || '30', 10);
        on(window, 'scroll', function () {
          if (nlShown) { return; }
          var doc = document.documentElement;
          var max = doc.scrollHeight - window.innerHeight;
          if (max > 0 && (window.scrollY / max) * 100 >= nlScrollPct) { nlOpen(); }
        }, { passive: true });
      }
      $$('[data-nl-close]', nlPopup).forEach(function (btn) { on(btn, 'click', function () { nlClose(true); }); });
      on(document, 'keydown', function (ev) { if (ev.key === 'Escape' && !nlPopup.hidden) { nlClose(true); } });
      var nlForm = $('#NewsletterPopupForm', nlPopup);
      if (nlForm) {
        on(nlForm, 'submit', function () {
          try {
            window.sessionStorage.setItem(nlReturnKey, JSON.stringify({ path: window.location.pathname, top: window.scrollY || 0 }));
          } catch (e) {}
        });
      }
    }
  }
  /* ---------------------------------------------------------- hero slider */
  $$('[data-hero]').forEach(safe(function (hero) {
    var slides = $$('[data-hero-slide]', hero);
    if (slides.length < 1) { return; }
    var dots = $$('[data-hero-dot]', hero);
    var progress = $('[data-hero-progress]', hero);
    var index = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (index < 0) { index = 0; }
    var autoplay = hero.getAttribute('data-autoplay') === 'true' && slides.length > 1 && !reduceMotion;
    var interval = parseInt(hero.getAttribute('data-interval') || '6500', 10);
    var timer = null, startTime = 0, rafId = null, paused = false;

    function render() {
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
        if (i === index) { s.removeAttribute('inert'); } else { s.setAttribute('inert', ''); }
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
        d.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      if (progress) {
        progress.style.transition = 'none';
        progress.style.width = '0%';
        void progress.offsetWidth;
        if (autoplay && !paused) {
          progress.style.transition = 'width ' + interval + 'ms linear';
          progress.style.width = '100%';
        }
      }
    }

    /* One slide at a time: fade the current slide out, then bring the next one in.
       Prevents two slides' text overlapping mid-transition. */
    function go(next) {
      if (slides.length < 2) { return; }
      var target = (next + slides.length) % slides.length;
      if (target === index) { return; }
      window.clearTimeout(timer);
      if (slides[index]) { slides[index].classList.remove('is-active'); }
      window.setTimeout(function () {
        index = target;
        render();
        restart();
      }, reduceMotion ? 0 : 260);
    }

    function tick() {
      if (!autoplay || paused || slides.length < 2) { return; }
      timer = window.setTimeout(function () { go(index + 1); }, interval);
    }

    function restart() { window.clearTimeout(timer); tick(); }

    on($('[data-hero-next]', hero), 'click', function () { go(index + 1); });
    on($('[data-hero-prev]', hero), 'click', function () { go(index - 1); });
    dots.forEach(function (dot, i) { on(dot, 'click', function () { go(i); }); });

    on(hero, 'mouseenter', function () { paused = true; window.clearTimeout(timer); });
    on(hero, 'mouseleave', function () { paused = false; if (autoplay) { render(); restart(); } });
    on(document, 'visibilitychange', function () {
      if (document.hidden) { window.clearTimeout(timer); } else if (autoplay) { restart(); }
    });
    on(hero, 'keydown', function (ev) {
      if (ev.key === 'ArrowRight') { go(index + 1); }
      if (ev.key === 'ArrowLeft') { go(index - 1); }
    });

    /* swipe */
    var startX = 0, startY = 0, moved = false;
    on(hero, 'touchstart', function (ev) {
      if (!ev.touches || ev.touches.length !== 1) { return; }
      startX = ev.touches[0].clientX; startY = ev.touches[0].clientY; moved = true;
    }, { passive: true });
    on(hero, 'touchend', function (ev) {
      if (!moved || !ev.changedTouches || !ev.changedTouches.length) { return; }
      moved = false;
      var dx = ev.changedTouches[0].clientX - startX;
      var dy = ev.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 46 && Math.abs(dx) > Math.abs(dy)) { go(index + (dx < 0 ? 1 : -1)); }
    });

    render();
    if (autoplay) { restart(); }
  }));
  /* --------------------------------------------------------------- drawers */
  var overlay = $('[data-overlay]');
  var openDrawer = null;

  function showOverlay(show) {
    if (!overlay) { return; }
    overlay.hidden = !show;
    window.requestAnimationFrame(function () { overlay.classList.toggle('is-open', show); });
  }
  function openPanel(drawer) {
    if (!drawer) { return; }
    closePanel();
    drawer.hidden = false;
    window.requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    lockScroll(true);
    showOverlay(true);
    openDrawer = drawer;
    var focusTarget = drawer.querySelector('[data-drawer-close], button, a[href]');
    if (focusTarget) { window.setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, 60); }
  }
  function closePanel() {
    if (!openDrawer) { showOverlay(false); lockScroll(false); return; }
    var drawer = openDrawer;
    drawer.classList.remove('is-open');
    window.setTimeout(function () { drawer.hidden = true; }, 420);
    openDrawer = null;
    lockScroll(false);
    showOverlay(false);
  }
  on(overlay, 'click', function () { closePanel(); });
  on(document, 'keydown', function (ev) { if (ev.key === 'Escape') { closePanel(); } });
  $$('[data-nav-open]').forEach(function (b) { on(b, 'click', function () { openPanel($('[data-nav-drawer]')); }); });
  $$('[data-nav-close]').forEach(function (b) { on(b, 'click', closePanel); });
  $$('[data-cart-open]').forEach(function (b) {
    on(b, 'click', function (ev) {
      if (S.cartType !== 'drawer' || !$('[data-cart-drawer]')) { return; } /* let it navigate to /cart */
      ev.preventDefault();
      openPanel($('[data-cart-drawer]'));
    });
  });
  $$('[data-cart-close]').forEach(function (b) { on(b, 'click', closePanel); });

  /* focus trap while a drawer is open */
  on(document, 'keydown', function (ev) {
    if (ev.key !== 'Tab' || !openDrawer) { return; }
    var focusables = $$('a[href], button:not([disabled]), input, select, textarea', openDrawer).filter(function (el) { return el.offsetParent !== null; });
    if (!focusables.length) { return; }
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
    else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
  });

  /* ------------------------------------------------------------------ cart */
  var cartState = null;

  function cartCountBubbles(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  function lineHTML(item) {
    var img = item.image ? item.image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_240x$1$2') : '';
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-line__variant">' + item.variant_title + '</p>' : '';
    return '' +
      '<div class="cart-line" data-line-key="' + item.key + '">' +
        '<a class="cart-line__media" href="' + item.url + '">' + (img ? '<img src="' + img + '" alt="" width="92" height="92" loading="lazy">' : '') + '</a>' +
        '<div class="cart-line__info">' +
          '<h3 class="cart-line__title"><a href="' + item.url + '">' + item.product_title + '</a></h3>' +
          variant +
          '<div class="quantity" data-line-qty>' +
            '<button type="button" data-qty-change="-1" aria-label="Decrease quantity">&minus;</button>' +
            '<input type="number" min="0" value="' + item.quantity + '" data-line-qty-input aria-label="Quantity">' +
            '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-line__price">' +
          '<div>' + formatMoney(item.final_line_price, S.moneyFormat) + '</div>' +
          '<button type="button" class="cart-line__remove" data-line-remove>Remove</button>' +
        '</div>' +
      '</div>';
  }

  function renderCart(cart) {
    cartState = cart;
    cartCountBubbles(cart.item_count);
    var body = $('[data-cart-body]');
    var drawer = $('[data-cart-drawer]');
    if (drawer) { drawer.classList.toggle('is-empty', cart.item_count === 0); }
    if (body) {
      if (!cart.items.length) {
        body.innerHTML = '<div class="empty-state"><p>Your cart is empty.</p><a class="btn" href="' + (window.Shopify && Shopify.routes ? Shopify.routes.all_products_collection_url : '/collections/all') + '">Continue shopping</a></div>';
      } else {
        body.innerHTML = cart.items.map(lineHTML).join('');
      }
    }
    $$('[data-cart-subtotal]').forEach(function (el) { el.textContent = formatMoney(cart.total_price, S.moneyFormat); });
    $$('[data-cart-item-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var threshold = parseInt(S.freeShipping || '0', 10);
    if (threshold > 0) {
      var remaining = Math.max(0, threshold * 100 - cart.total_price);
      $$('[data-free-ship-text]').forEach(function (el) {
        el.textContent = remaining > 0
          ? 'Add ' + formatMoney(remaining, S.moneyFormat) + ' more for free U.S. shipping.'
          : 'You have unlocked free U.S. shipping.';
      });
      $$('[data-free-ship-fill]').forEach(function (el) {
        el.style.width = Math.min(100, (cart.total_price / (threshold * 100)) * 100) + '%';
      });
    }
    $$('[data-cart-page]').forEach(function (el) {
      el.innerHTML = cart.item_count === 0
        ? '<div class="empty-state"><h2>Your cart is empty</h2><p>Start with our best-selling silhouettes.</p><a class="btn" href="/collections/all">Shop all bags</a></div>'
        : cart.items.map(lineHTML).join('');
    });
  }

  function getCart() {
    return fetch(ROUTES.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(key, quantity) {
    return fetch(ROUTES.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); return cart; });
  }

  function addToCart(formData) {
    return fetch(ROUTES.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function (r) {
      if (!r.ok) { return r.json().then(function (e) { throw e; }); }
      return r.json();
    }).then(function () { return getCart(); });
  }

  /* cart drawer / page interactions (event delegation) */
  on(document, 'click', function (ev) {
    var qtyBtn = ev.target.closest('[data-qty-change]');
    if (qtyBtn) {
      ev.preventDefault();
      var wrap = qtyBtn.closest('.quantity');
      var input = wrap ? wrap.querySelector('input') : null;
      if (input) {
        var step = parseInt(qtyBtn.getAttribute('data-qty-change'), 10) || 0;
        var minQty = parseInt(input.getAttribute('min') || '0', 10);
        var next = Math.max(minQty, (parseInt(input.value, 10) || 0) + step);
        input.value = next;
        var line = qtyBtn.closest('[data-line-key]');
        if (line) { changeLine(line.getAttribute('data-line-key'), next); }
      }
      return;
    }
    var removeBtn = ev.target.closest('[data-line-remove]');
    if (removeBtn) {
      ev.preventDefault();
      var lineEl = removeBtn.closest('[data-line-key]');
      if (lineEl) { changeLine(lineEl.getAttribute('data-line-key'), 0); }
      return;
    }
    var submitCart = ev.target.closest('[data-cart-page-submit]');
    if (submitCart) {
      var cartForm = submitCart.closest('form');
      if (cartForm) { cartForm.submit(); }
    }
  });


  /* add to cart: product forms + quick add */
  $$('form[data-product-form], form[data-quick-add], [data-product-root] form[action*="/cart/add"]').forEach(function (form) {
    on(form, 'submit', function (ev) {
      if (!window.fetch) { return; } /* progressive enhancement: normal POST */
      ev.preventDefault();
      var btn = form.querySelector('[data-add-button]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.innerHTML = 'Adding…'; btn.classList.add('is-disabled'); }
      addToCart(new FormData(form)).then(function () {
        if (btn) { btn.innerHTML = original; btn.classList.remove('is-disabled'); }
        var openBtn = $('[data-cart-open]');
        if (S.cartType === 'drawer' && $('[data-cart-drawer]')) { openPanel($('[data-cart-drawer]')); }
        else if (openBtn) { window.location.href = ROUTES.cart; }
      }).catch(function (err) {
        if (btn) { btn.innerHTML = original; btn.classList.remove('is-disabled'); }
        var msg = (err && err.description) ? err.description : 'Sorry, this item could not be added. Please try again.';
        var note = form.querySelector('[data-form-error]');
        if (note) { note.textContent = msg; note.hidden = false; } else { window.alert(msg); }
      });
    });
  });
  /* ------------------------------------------------------------ header search */
  $$('[data-search-toggle]').forEach(function (btn) {
    on(btn, 'click', function (ev) {
      ev.preventDefault();
      var panel = $('[data-header-search]');
      if (!panel) { return; }
      var isOpen = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) { var input = panel.querySelector('input[type="search"]'); if (input) { input.focus(); } }
    });
  });
  on(document, 'keydown', function (ev) {
    if (ev.key !== 'Escape') { return; }
    var open = $('[data-header-search].is-open');
    if (open) { open.classList.remove('is-open'); }
  });

  on(document, 'click', function (event) {
    var swatch = event.target.closest('[data-card-swatch]');
    if (!swatch || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) { return; }
    var card = swatch.closest('.product-card');
    if (!card) { return; }
    event.preventDefault();
    var imageUrl = swatch.getAttribute('data-card-image-src');
    var image = $('.product-card__img:not(.product-card__img--hover)', card);
    if (image && imageUrl) {
      image.removeAttribute('srcset');
      image.src = imageUrl;
      image.alt = swatch.getAttribute('data-card-image-alt') || image.alt;
    }
    var hoverImage = $('.product-card__img--hover', card);
    var hoverUrl = swatch.getAttribute('data-card-hover-src');
    if (hoverImage && hoverUrl) {
      hoverImage.removeAttribute('srcset');
      hoverImage.src = hoverUrl;
      hoverImage.alt = swatch.getAttribute('data-card-hover-alt') || '';
    }
    card.classList.toggle('product-card--no-hover-image', !hoverUrl);
    card.classList.add('product-card--swatch-selected');
    $$('[data-card-swatch]', card).forEach(function (dot) {
      var selected = dot === swatch;
      dot.classList.toggle('is-active', selected);
      if (selected) { dot.setAttribute('aria-current', 'true'); }
      else { dot.removeAttribute('aria-current'); }
    });
    var href = swatch.getAttribute('href');
    var mediaLink = $('.product-card__media', card);
    var titleLink = $('.product-card__title a', card);
    var optionsLink = $('.product-card__quick a', card);
    if (mediaLink) { mediaLink.href = href; }
    if (titleLink) { titleLink.href = href; }
    if (optionsLink) { optionsLink.href = href; }
  });

  /* ---------------------------------------------------- product gallery */
  $$('[data-gallery]').forEach(safe(function (gallery) {
    var slides = $$('[data-gallery-slide]', gallery);
    var thumbs = $$('[data-gallery-thumb]', gallery);
    if (!slides.length) { return; }
    var selectedIndex = 0;
    var productRoot = gallery.closest('[data-product-root]');
    var colorOption = productRoot && $('[data-color-option]', productRoot);
    var colorValues = colorOption ? $$('input[type="radio"], option', colorOption).map(function (item) {
      return String(item.value || '').toLowerCase().trim();
    }).filter(function (value, index, all) { return value && all.indexOf(value) === index; }) : [];
    function colorPosition(alt, value) {
      var position = alt.indexOf(value);
      while (position !== -1) {
        var before = position === 0 ? '' : alt.charAt(position - 1);
        var after = alt.charAt(position + value.length);
        if (!/[a-z0-9]/i.test(before) && !/[a-z0-9]/i.test(after)) { return position; }
        position = alt.indexOf(value, position + 1);
      }
      return -1;
    }
    var mediaColors = thumbs.map(function (thumb) {
      var image = $('img', thumb);
      var alt = image ? image.alt.toLowerCase() : '';
      var matches = colorValues.map(function (value) {
        return { value: value, position: colorPosition(alt, value) };
      }).filter(function (match) { return match.position !== -1; });
      matches.sort(function (a, b) { return a.position - b.position || b.value.length - a.value.length; });
      return matches.length ? matches[0].value : '';
    });
    var groupByColor = colorValues.length > 1 && slides.length === thumbs.length &&
      mediaColors.every(function (color) { return !!color; }) &&
      colorValues.every(function (color) { return mediaColors.indexOf(color) !== -1; });
    function visibleIndexes() {
      return slides.map(function (_, i) { return i; }).filter(function (i) { return !slides[i].hidden; });
    }
    function nextVisibleIndex(i, direction) {
      for (var n = 0; n < slides.length; n++) {
        var candidate = (i + direction * n + slides.length * 2) % slides.length;
        if (!slides[candidate].hidden) { return candidate; }
      }
      return 0;
    }
    function select(i) {
      i = nextVisibleIndex(i, 1);
      selectedIndex = i;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      thumbs.forEach(function (t, idx) {
        t.classList.toggle('is-active', idx === i);
        t.setAttribute('aria-current', idx === i ? 'true' : 'false');
      });
    }
    thumbs.forEach(function (thumb, i) {
      on(thumb, 'click', function (ev) { ev.preventDefault(); select(i); });
    });
    on(gallery, 'product:variant-change', function (ev) {
      if (!groupByColor) { return; }
      var detail = ev.detail || {};
      var color = String(detail.color || '').toLowerCase().trim();
      if (colorValues.indexOf(color) === -1) { return; }
      slides.forEach(function (slide, i) {
        var hidden = mediaColors[i] !== color;
        slide.hidden = hidden;
        if (thumbs[i]) { thumbs[i].hidden = hidden; }
      });
      var visible = visibleIndexes();
      if (!visible.length) {
        slides.forEach(function (slide, i) { slide.hidden = false; if (thumbs[i]) { thumbs[i].hidden = false; } });
        visible = visibleIndexes();
      }
      var featured = visible.find(function (i) { return slides[i].getAttribute('data-media-id') === String(detail.mediaId); });
      select(featured === undefined ? visible[0] : featured);
    });
    /* keyboard + swipe */
    var startX = 0;
    on(gallery, 'touchstart', function (ev) { if (ev.touches && ev.touches.length === 1) { startX = ev.touches[0].clientX; } }, { passive: true });
    on(gallery, 'touchend', function (ev) {
      if (!ev.changedTouches || !ev.changedTouches.length) { return; }
      var dx = ev.changedTouches[0].clientX - startX;
      if (Math.abs(dx) < 46) { return; }
      var current = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      select(nextVisibleIndex(current + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1));
    });

    /* click to zoom */
    var dialog = $('[data-zoom-dialog]');
    if (dialog) {
      var zoomImg = $('[data-zoom-image]', dialog);
      var zoomIndex = 0;
      var zoomTrigger = null;
      function showZoom(i) {
        zoomIndex = nextVisibleIndex(i, i >= zoomIndex ? 1 : -1);
        var slide = slides[zoomIndex];
        var src = slide.getAttribute('data-image-src');
        if (src && zoomImg) { zoomImg.src = src; }
        var preview = $('img', slide);
        if (zoomImg) { zoomImg.alt = preview ? preview.alt : ''; }
        select(zoomIndex);
      }
      $$('[data-zoom-open]', gallery).forEach(function (btn) {
        on(btn, 'click', function (ev) {
          ev.preventDefault();
          zoomTrigger = btn;
          showZoom(selectedIndex);
          dialog.hidden = false;
          lockScroll(true);
          var close = $('[data-zoom-close]', dialog);
          if (close) { close.focus(); }
        });
      });
      var closeDialog = function () {
        dialog.hidden = true;
        lockScroll(false);
        if (openDrawer) { lockScroll(true); }
        if (zoomTrigger) { zoomTrigger.focus(); }
      };
      on($('[data-zoom-close]', dialog), 'click', closeDialog);
      on($('[data-zoom-prev]', dialog), 'click', function () { showZoom(zoomIndex - 1); });
      on($('[data-zoom-next]', dialog), 'click', function () { showZoom(zoomIndex + 1); });
      on(dialog, 'click', function (ev) { if (ev.target === dialog) { closeDialog(); } });
      on(document, 'keydown', function (ev) {
        if (dialog.hidden) { return; }
        if (ev.key === 'Escape') { closeDialog(); }
        if (ev.key === 'ArrowLeft') { ev.preventDefault(); showZoom(zoomIndex - 1); }
        if (ev.key === 'ArrowRight') { ev.preventDefault(); showZoom(zoomIndex + 1); }
      });
    }
  }));

  /* ------------------------------------------------- variants + sticky bar */
  $$('[data-product-root]').forEach(safe(function (root) {
    var variantsEl = $('[data-variants-json]', root) || $('[data-variants-json]');
    var form = $('form[data-product-form]', root);
    if (!form) { return; }
    var variants = [];
    try { variants = variantsEl ? JSON.parse(variantsEl.textContent) : []; } catch (e) { variants = []; }

    function currentOptions() {
      var selects = $$('[data-option-select], fieldset', form);
      var chosen = [];
      $$('[data-option-index]', form).forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var checked = group.querySelector('input:checked');
        var select = group.querySelector('select');
        chosen[idx] = checked ? checked.value : (select ? select.value : null);
      });
      return chosen;
    }

    function updateProduct() {
      if (!variants.length) { return; }
      var chosen = currentOptions();
      var match = variants.filter(function (v) {
        return v.options.every(function (opt, i) { return chosen[i] === undefined || chosen[i] === null || String(opt) === String(chosen[i]); });
      })[0];
      if (!match) { return; }
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) { idInput.value = match.id; }
      var price = $('[data-price]', root);
      if (price) {
        price.innerHTML = match.compare_at_price > match.price
          ? '<span class="is-sale">' + match.price_formatted + '</span> <s>' + match.compare_at_price_formatted + '</s>'
          : match.price_formatted;
      }
      var btn = form.querySelector('[data-add-button]');
      if (btn) {
        btn.disabled = !match.available;
        btn.innerHTML = match.available ? (btn.getAttribute('data-label') || 'Add to cart') : 'Sold out';
      }
      var stickyBtn = $('[data-sticky-atc] [data-add-button]');
      if (stickyBtn) {
        stickyBtn.disabled = !match.available;
        stickyBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
      var stickyInfo = $('[data-sticky-atc] .pdp__sticky-info span');
      if (stickyInfo) { stickyInfo.textContent = match.price_formatted; }
      var stickyImage = $('[data-sticky-atc] .pdp__sticky-media img');
      if (stickyImage && match.featured_media_src) {
        stickyImage.src = match.featured_media_src;
        stickyImage.alt = match.featured_media_alt || '';
      }
      var gallery = $('[data-gallery]', root);
      if (gallery) {
        var colorGroup = $('[data-color-option]', form);
        var colorIndex = colorGroup ? parseInt(colorGroup.getAttribute('data-option-index'), 10) : -1;
        gallery.dispatchEvent(new CustomEvent('product:variant-change', {
          detail: { color: colorIndex >= 0 ? chosen[colorIndex] : null, mediaId: match.featured_media_id }
        }));
      }
      try {
        var url = new URL(window.location.href);
        if (match.id) { url.searchParams.set('variant', match.id); }
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    $$('[data-option-index]', form).forEach(function (group) {
      $$('input, select', group).forEach(function (input) {
        on(input, 'change', function () {
          $$('label', group).forEach(function (label) { label.classList.toggle('is-selected', !!label.querySelector('input:checked')); });
          $$('select', group).forEach(function (sel) { var lbl = sel.closest('.pdp__option'); if (lbl) { lbl.classList.add('is-selected'); } });
          var selectedLabel = $('.pdp__option-label span', group);
          var selectedInput = group.querySelector('input:checked');
          if (selectedLabel && selectedInput) { selectedLabel.textContent = selectedInput.value; }
          updateProduct();
        });
      });
    });

    /* sticky bar visibility driven by the main buy button */
    var sticky = $('[data-sticky-atc]');
    var anchor = $('[data-buy-anchor]', root);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      sio.observe(anchor);
    }
    updateProduct();
  }));

  /* ------------------------------------------- filters & sort auto-submit */
  $$('[data-facets] input[type="checkbox"], [data-facets] input[type="radio"]').forEach(function (input) {
    on(input, 'change', function () { if (input.form) { input.form.submit(); } });
  });
  $$('[data-sort-select]').forEach(function (sel) {
    on(sel, 'change', function () { if (sel.form) { sel.form.submit(); } });
  });
  /* --------------------------------------------------- initial cart state */
  if (document.body.classList.contains('template-cart') || $('[data-cart-count]') || $('[data-cart-body]')) {
    getCart().catch(function () { /* offline or blocked: server-rendered markup stays */ });
  }
})();
